enum ProfileType {
  CUSTOMER = "customer",
  DRIVER = "driver",
}

export default ProfileType;
